module.exports = __webpack_public_path__ + "img/invite-expired.b7d46aff.png";